/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/*global Ingest*/

/**
 * Simple singleton style container so all analytics related stuff has a centralized point.
 */
var iaw = iaw||{};

iaw.analytics = {

	/**
	 * Override to turn analytics on or off
	 */
	enabled: false,

	pipQuery: {
		//Events
		category: 'Mobile Creations',
		pipAware: {
			subCategory: 'See Start Screen',
			eventName: 'See Start Screen'
		},
		pipTry: {
			subCategory: 'Click Mobile Creations',
			eventName : 'Click Mobile Creations'
		},
		pipSucceedProject: {
			subCategory: 'Open Mobile Creations',
			eventName: 'Open Mobile Creations'
		},
		pipSucceedProjectFile: {
			subCategory: 'Open Mobile Creations',
			eventName : 'Open App Page'
		},
		pipNoAssetUI: {
			subCategory : 'No Mobile Creations',
			eventName : 'See No Asset UI'
		},
		pipGetApp: {
			subCategory : 'No Mobile Creations',
			eventName : 'Click on Get App'
		},
		pipTimeOutOnMCClick: {
			subCategory: 'TimeOutOnMCClick',
			eventName: 'TimeOutOnMCClick'
		},
		pipTimeOutOnProjectClick: {
			subCategory: 'TimeOutOnProjectClick',
			eventName: 'TimeOutOnProjectClick'
		},
		pipTimeOutOnFileClick: {
			subCategory: 'TimeOutOnFileClick',
			eventName: 'TimeOutOnFileClick'
		},
		pipTryAgainOnMCClick: {
			subCategory: 'TryAgainOnMCClick',
			eventName: 'TryAgainOnMCClick'
		},
		pipTryAgainOnProjectClick: {
			subCategory: 'TryAgainOnProjectClick',
			eventName: 'TryAgainOnProjectClick'
		},
		pipTryAgainOnFileClick: {
			subCategory: 'TryAgainOnFileClick',
			eventName: 'TryAgainOnFileClick'
		}
	},

	/**
	 * Configure analytics for future analytics calls.
	 *
	 * @param client        client ID string
	 * @param hostData      data from the host
	 * @param psdkData      data fron the PSDK
	 * @param mode          string indicating the server mode (prod, stage, or dev)
	 */
	config: function(client, hostData, psdkData, mode) {

		this.enabled = hostData.userTrackingEnabled;
		this.ingest.configure(client, hostData, psdkData, mode);
	},

	/**
	 * Compose the passed URL for proper analytics logging - this means
	 * adding in analytic query params and moving any deep links to the end.
	 * This is primarily for Adobe Learn.
	 *
	 * @param url	 original URL to add analytic params into
	 * @return String containing the URL properly ordered with analytics query arguments.
	 */
	composeURLWithAnalyticsQueryString: function(url) {

		var composedURL = url;

		if (composedURL) {
			var analyticsQuery	= this.getAnalyticsQueryString();

			// check for deep links
			var deepLinkIndex	= composedURL.indexOf('#');
			var deepLink		= '';

			if (deepLinkIndex >= 0) {
				deepLink = composedURL.substr(deepLinkIndex);
				composedURL = composedURL.substr(0, deepLinkIndex);
			}

			// check for existing query which it could have
			var querySep = ((composedURL.indexOf('?') < 0) ? '?' : '&');

			composedURL += (querySep + analyticsQuery + deepLink);
		}

		return composedURL;
	},


	/**
	 * Build the passthrough analytics string for
	 *
	 * @return String containing the query arguments.
	 */
	getAnalyticsQueryString: function() {

		var hostData = iaw.store.get('host');

		return 'locale='+hostData.language+
				'&x-product='+hostData.hostID+'%2F'+hostData.appVersion+
				'&x-product-location=CCXStart-'+hostData.displayMode+'%2F'+hostData.radarVersion+
				'&x-radarSession='+hostData.radarSessionGUID+
				'&x-appSession='+hostData.sessionGUID+
				'&ute='+hostData.userTrackingEnabled;
	},

	/**
	 * AdobePIP/Highbeam Analytics
	 */
	pip: {
		kCategory: 'CCXStart',
		fnftCategory: 'CCXFNFT',

		/**
		 * Log Highbeam events to the hosting application.
		 *
		 * @param pipCategory       Highbeam category classification string
		 * @param pipSubCategory    Highbeam sub-category classification string
		 * @param pipEvent          Highbeam event name string
		 */
		logEvent: function( pipCategory, pipSubCategory, pipEvent ) {
			if ( iaw.analytics.enabled ) {
				if ( pipEvent ) {
					// Highbeam events are limited to 128 characters
					pipEvent = (pipEvent.length < 128) ? pipEvent: pipEvent.substr(0, 127);
				}

				var pipJSO = {
					dataType: 'event',
					category: pipCategory,
					subcategory: pipSubCategory,
					eventname: pipEvent
				};

				var pipJSON = JSON.stringify( pipJSO );

				if ( iaw.cepUtil ) {
					iaw.cepUtil.sendEvent( iaw.cepUtil.events.LOGPIP, pipJSON );
				}
			}
		},

		/**
		 * Log Highbeam group data to the hosting application.
		 *
		 * @param pipGroupName		Highbeam group name
		 * @param data				Highbeam group data
		 * @param category			Highbeam group category
		 * @param subcategory		Highbeam group subcategory
		 */
		logDataGroupEvent: function( pipGroupName, data, category, subcategory ) {

			if (iaw.analytics.enabled) {
				var group_Data_Array = [];

				if (data) {
					Object.keys(data).forEach(function(key) {
						group_Data_Array.push({
							'columnname': key,
							'value': data[key].toString()
						});
					});
				}

				var pipJSON = {
					dataType: 'group',
					category: category,
					subcategory: subcategory,
					groupname: pipGroupName,
					Group_Data_Array: group_Data_Array
				};

				pipJSON = JSON.stringify( pipJSON );

				if ( iaw.cepUtil ) {
					iaw.cepUtil.sendEvent( iaw.cepUtil.events.LOGPIP, pipJSON );
				}
			}
		},

		/**
		 * Log Highbeam group data to the hosting application for FNFT. For PHXS only so far.
		 *
		 */
		logFNFTDataGroupEvent: function( pipGroupName, data ) {
			// For PHXS only so far.
			if ('PHXS' === iaw.store.get(['host', 'hostID'])) {
				this.logDataGroupEvent(pipGroupName, data, this.fnftCategory, 'Interaction');
			}
		},

		/**
		 * Utility method to log an 'Interaction' event.
		 *
		 * @param interactionEvent  event to log
		 */
		logInteractionEvent: function( interactionEvent ) {

			this.logEvent( this.kCategory, 'Interaction', interactionEvent );
		},

		/**
		 * Utility method to log an 'Interaction' event for FNFT. For PHXS only so far.
		 *
		 * @param interactionEvent  event to log
		 */
		logFNFTInteractionEvent: function( interactionEvent ) {

			if ('PHXS' === iaw.store.get(['host', 'hostID'])) {
				this.logEvent( this.fnftCategory, 'Interaction', interactionEvent );
			}
		},

		/**
		 * Utility method to log an 'Failure' event.
		 *
		 * @param failEvent         event to log
		 */
		logFailureEvent: function( failEvent ) {

			this.logEvent( this.kCategory, 'Failure', failEvent );
		}
	}, // end of pip container

	/**
	 * Ingest Analytics
	 */
	ingest: {
		/**
		 * Ingest configuration objects
		 */

		imsToken: null,
		ingestLibReady: false,
		instance: null,
		psdkData: null,

		basePayloadData: {
			eventType:			null,
			eventGUID:			null,
			dts:				null,
			userGUID:			null,
			subscriptionStatus:	null,
			productName:		null,
			productVersion:		null,
			productLanguage:	null,
			displayCount:		0,
			radarVersion:		null,
			userAgent:			navigator.userAgent,
			radarSessionGUID:	null,
			appSessionGUID:		null
		},

		renderedCards: {},  // map of rendered card events

		// since many things load asynchronously, some event actions can happen before
		// the Ingest lib scripts have completed - therefore we pre-queue some events
		// that get processed once the lib is ready
		prequeuedEvents: [],

		/**
		 * Configure Ingest for future analytics calls.
		 *
		 * @param client        client ID string
		 * @param hostData      data from the host
		 * @param psdkData      data fron the PSDK
		 * @param mode          string indicating the server mode (prod, stage, or dev)
		 */
		configure: function( client, hostData, psdkData, mode ) {
			var self = this;
			mode = mode || 'prod';
			this.psdkData = psdkData;

			// Ingest.js library configuration
			var options = {
				ENVIRONMENT: mode,
				ANALYTICS_API_KEY: client,
				ANALYTICS_X_PRODUCT: hostData.hostID+'%2F'+hostData.appVersion,
				ANALYTICS_PROJECT: 'ccx-cmdn-service',
				ANALYTICS_USER_REGION: hostData.countryCode,
				ANALYTICS_INGEST_TYPE: 'dunamis',
				ANALYTICS_MAX_QUEUED_EVENTS: 50,
				ANALYTICS_DEBOUNCE: 0,
				TIMESTAMP_PROPERTY_NAME: 'event.dts_end'
			};

			var dependencies = {
				log: function(msg) {
					iaw.log.console(msg);
				},
				getAccessToken: function(callback) {
					if (self.imsToken) {
						callback(null, self.imsToken);
					}
					else { // handle case when no IMS token is available
						iaw.cepUtil.getIMSAccessToken(function( token ) {
							self.imsToken = token;
							callback(null, token);
						});
					}
				},
				clearAccessToken: function() {
					self.imsToken = null;
					iaw.cepUtil.clearAccessToken();
				}
			};
			// Get Ingest instance (Ingest supports multiple instances since v1.0)
			this.instance = Ingest.createInstance(dependencies, options);
			this.instance.enable(iaw.analytics.enabled);

			// configure basic payload
			this.basePayloadData.userGUID           = hostData.adobeGUID;
			this.basePayloadData.subscriptionStatus = hostData.accountStatus;
			this.basePayloadData.productName        = hostData.hostID;
			this.basePayloadData.productVersion     = hostData.appVersion;
			this.basePayloadData.productLanguage    = hostData.language;
			this.basePayloadData.displayCount       = hostData.displayCount;
			this.basePayloadData.radarVersion       = hostData.radarVersion;
			this.basePayloadData.modeID             = hostData.displayMode;
			this.basePayloadData.radarSessionGUID   = hostData.radarSessionGUID;
			this.basePayloadData.appSessionGUID     = hostData.sessionGUID;
			if (hostData.displayMode !== 'fnft') {
				this.basePayloadData.appLaunchCount = hostData.launchCount;
			}
			this.basePayloadData.AUMSegments        = null;
			this.basePayloadData.hvaFlow			= null;
			this.basePayloadData.displayMode		= null;
			if (psdkData) {
				this.basePayloadData.AUMSegments = psdkData.segmentID || 'none';
				this.basePayloadData.hvaFlow = psdkData.hvaFlow || 'none';

				// find the control card section for this display mode
				for (var index = 0; index < psdkData.cardControl.length && !this.basePayloadData.displayMode; index++) {
					if ( psdkData.cardControl[index].modeID === hostData.displayMode ) {
						this.basePayloadData.displayMode = psdkData.cardControl[index].cardOrder.toString();
					}
				}
			}
			// we only want to add the trialEndDts parameter if we are a trial account
			if (hostData.accountStatus !== 'paid' && hostData.secondsLeftInTrial !== undefined) {
				this.basePayloadData.trialEndDts = iaw.util.getTrialEndDate(hostData.secondsLeftInTrial);
			}

			iaw.log.console('Ingest configured ('+mode+')');
			this.ingestLibReady = true;

			// now handle any prequeued events
			this.processPrequeuedEvents();
		},

		/**
		 * Create a clone of the Ingest base payload data.
		 *
		 * @param needsAEMData		boolean flag to indicated that AEM card data is needed in the payload
		 * @return A new object based off the preset payload data.
		 */
		createPayload: function(needsAEMData) {

			var payload = JSON.parse(JSON.stringify(this.basePayloadData));

			payload.eventGUID = iaw.util.generateGUID();
			payload['source.client_id'] = iaw.cepUtil.getIMSClientId();

			if (!needsAEMData) {
				delete payload.AUMSegments;
				delete payload.hvaFlow;
				delete payload.displayMode;
			}
			return payload;
		},

		/**
		 * If the Ingest library is not loaded/configured prior to calling a postEvent,
		 * then the event gets pre-queued. So once the library is ready then we process
		 * all the events.
		 */
		processPrequeuedEvents: function() {

			var self = this;

			this.prequeuedEvents.forEach(function(payload) {

				// update base payload properties - dont use iaw.util.assign here
				// as it would overwrite properties we dont want
				for (var prop in self.basePayloadData) {
					if (!payload[prop] && self.basePayloadData[prop]) {
						payload[prop] = self.basePayloadData[prop];
					}
				}
				self.postEvent(payload);
			});
		},

		/**
		 * Post the analytics call to the Ingest data server.
		 *
		 * @param payload           payload data to send
		 */
		postEvent: function( payload ) {
			if (this.ingestLibReady) {
				if (payload.debugIt) {
					window.alert(JSON.stringify(payload));
				}
				else {
					this.instance.postEvent(payload);
				}
			}
			else {
				this.prequeuedEvents.push(payload);
			}
		},

		/**
		 * Flush the queued events to the Ingest data server.
		 *
		 */
		flushEvent: function() {
			if (this.ingestLibReady) {
				this.instance.flush(true);
			}
		},

		/**
		 * Log a screen state event.
		 *
		 * @param mode      values: 'open', 'close-manual', 'close-auto', 'do-not-show'
		 */
		logScreenStateEvent: function( mode ) {
			var ingestPayloadData = this.createPayload();

			ingestPayloadData.eventType          = 'screen-state';
			ingestPayloadData.welcomeScreenState = mode;

			this.postEvent(ingestPayloadData);
		},

		/**
		 * Log a Ingest event on the PSDK engagement card.
		 *
		 * @param type              type of event
		 * @param cardData          card data from the PSDK
		 */
		logEngagementCardEvent: function( type, cardData ) {

			if ((type === 'rendered' && (!this.renderedCards[cardData.cardID])) ||
				(type !== 'rendered')) {
				var ingestPayloadData = this.createPayload(true);

				switch (type) {
					case 'rendered':
						ingestPayloadData.eventType = 'eng-card-rendered';
						this.renderedCards[cardData.cardID] = true;
						break;

					case 'clicked':
						ingestPayloadData.eventType = 'eng-card-click';
						break;

					default:
						iaw.log.conosle('Invalid Ingest card event');
						break;
				}
				ingestPayloadData.cardTypeID         = cardData.cardTypeID;
				ingestPayloadData.cardTypeName       = cardData.cardType;
				ingestPayloadData.cardID             = cardData.cardID;
				ingestPayloadData.cardName           = cardData.cardName;
				ingestPayloadData.width              = cardData.width;
				ingestPayloadData.displayTemplate    = cardData.displayTemplate    || '';
				ingestPayloadData.startDTS           = cardData.startDTS           || '';
				ingestPayloadData.endDTS             = cardData.endDTS             || '';
				ingestPayloadData.actionURL          = cardData.actionURL          || '';
				ingestPayloadData.urlLinkType        = cardData.urlLinkType        || '';

				// invertPresentation is a boolean - so usual logic above doesnt work
				ingestPayloadData.invertPresentation = (typeof cardData.invertPresentation !== 'undefined') ? cardData.invertPresentation: 'n/a';

				// optional params, some are not implemented yet in AEM,
				// so strip them out until they are
				if ( cardData.campaignCode ) {
					ingestPayloadData.campaignCode = cardData.campaignCode;
				}
				if ( cardData.recipe ) {
					ingestPayloadData.recipe = cardData.recipe;
				}
				if ( cardData.aumSegments ) {
					ingestPayloadData.aumSegments = cardData.aumSegments;
				}
				// price copy is only present on offer cards
				if ( cardData.priceCopy ) {
					ingestPayloadData.priceCopy = cardData.priceCopy;
				}
				// some cards like AdobeStock, may have a promo ID, if so, then log it
				if ( cardData.promoID ) {
					ingestPayloadData.promoID = cardData.promoID;
				}
				// only present on AdobeStock cards
				if ( cardData.as_query ) {
					ingestPayloadData.actionURL = ingestPayloadData.actionURL+'&'+cardData.as_query;
				}
				// playlists fields present on all engagement stream cards
				if (this.psdkData) {
					ingestPayloadData.eventParams = {
						'persona': this.psdkData.persona || 'none',
						'skill': this.psdkData.skill || 'none',
						'appLaunchBucket': this.psdkData.appLaunchBucket || 'none',
						'entitlement': this.psdkData.entitlement || 'none',
						'entitlementType': this.psdkData.entitlementType || 'none',
						'marketSegment': this.psdkData.marketSegment || 'none',
						'derivedPersona': this.psdkData.derivedPersona || 'none',
						'derivedSkill': this.psdkData.derivedSkill || 'none',
						'derivedAppLaunchBucket': this.psdkData.derivedAppLaunchBucket || 'none',
						'bonusLaunch': this.psdkData.bonusLaunch || 'none',
						'ccxVersion': this.psdkData.ccxVersion || 'none',
						'radarSessionGUID': this.psdkData.radarSessionGUID || 'none'
					};
				}

				this.postEvent(ingestPayloadData);
			}
		},

		/**
		 * Log a view change event.
		 *
		 * @param viewData           view data to log
		 */
		logViewChangeEvent: function( viewData ) {

			var ingestPayloadData = this.createPayload();

			ingestPayloadData.eventType     = 'uc-section';
			ingestPayloadData.sectionView   = viewData.sectionView;
			ingestPayloadData.sectionType   = viewData.sectionType;
			this.postEvent(ingestPayloadData);
		},

		/**
		 * Log a file/lib/etc. open event.
		 *
		 * @param itemData          item data to log
		 */
		logItemOpenedEvent: function( itemData ) {

			var ingestPayloadData = this.createPayload();

			ingestPayloadData.eventType     = 'uc-file-open';
			ingestPayloadData.fileType      = itemData.fileType;
			ingestPayloadData.fileOpenType  = itemData.openType;
			ingestPayloadData.sectionView	= itemData.sectionView;
			if (typeof itemData.itemPosition !== 'undefined') {
				ingestPayloadData.itemPosition  = itemData.itemPosition;
			}
			if (itemData.ucAction) {
				ingestPayloadData.ucAction = itemData.ucAction;
			}
			if (itemData.cardID) {
				ingestPayloadData.cardID = itemData.cardID;
			}
			if (itemData.eventAction) {
				ingestPayloadData.eventAction = itemData.eventAction;
			}
			this.postEvent(ingestPayloadData);
		},

		/**
		 * Log a miscellaneous event.
		 *
		 * @param itemData          item data to log
		 */
		logMiscellaneousEvent: function( itemData ) {

			var ingestPayloadData = this.createPayload();

			ingestPayloadData.eventType = itemData.eventType || 'uc-misc';

			for (var key in itemData) {
				ingestPayloadData[key] = itemData[key];
			}

			this.postEvent(ingestPayloadData);
		},

		/**
		 * Log a Ingest event on the Mobile Creations item.
		 *
		 * @param eventAction       render,click, or open
		 * @param cardTypeName		null/project/pages/appcards/appdetail
		 * @param cardName			will be null in most cases, added here for future expansion
		 */
		logMobileCreationsEvent: function( mcEventData ) {

			var ingestPayloadData = this.createPayload();

			ingestPayloadData.eventType	= 'mobile-creations';

			for (var prop in mcEventData) {
				if (mcEventData[prop]) {
					ingestPayloadData[prop] = mcEventData[prop];
				}
			}
			this.postEvent(ingestPayloadData);
		},

		/**
		 * Build up the event structure or the differnt types of Mobile Creations events to Ingest.
		 *
		 * @param mode			string object indicating the event mode
		 * @param action		string containg type of action 'click' or 'render'
		 * @param cardData		JSON object containing the data to log
		 */
		constructMobileCreationsEventData: function(mode, action, cardData) {

			var mcEventData = {
				eventAction:	action,
				cardTypeName:	''
			};

			// setup card data
			if (mode !== 'item') {
				for (var prop in cardData) {
					if (cardData) {
						mcEventData[prop] = cardData[prop];
					}
				}
			}

			// setup mode op
			switch (mode) {
				case 'project':
					mcEventData.cardTypeName = 'project';
					break;

				case 'pages':
					mcEventData.cardTypeName  = 'pages';
					break;

				case 'app':
					mcEventData.cardTypeName = 'appcards';
					break;

				case 'item':
					mcEventData.cardTypeName = 'item';
					mcEventData.cardName = cardData.syncGroup || null;
					mcEventData.cardID = cardData.compositeId || null;
					break;

				default:
					iaw.log.console('Invalid Ingest Mobile Creations '+action+' event');
					mcEventData = null;
					break;
			}

			return mcEventData;
		},

		/**
		 * Log a user clicked event for Mobile Creations to Ingest.
		 *
		 * @param mode			string object indicating the event mode
		 * @param cardData		JSON object containing the data to log
		 */
		logMobileCreationsRenderedEvent: function(mode, cardData) {

			var mcEventData = this.constructMobileCreationsEventData(mode, 'render', cardData);

			if (mcEventData) {
				this.logMobileCreationsEvent(mcEventData);
			}
		},

		/**
		 * Log a user clicked event for Mobile Creations to Ingest.
		 *
		 * @param mode			string object indicating the event mode
		 * @param cardData		JSON object containing the data to log
		 */
		logMobileCreationsClickedEvent: function(mode, cardData) {

			var action = (mode !== 'item') ? 'click' : 'open';
			var mcEventData = this.constructMobileCreationsEventData(mode, action, cardData);

			if (mcEventData) {
				this.logMobileCreationsEvent(mcEventData);
			}
		},

		/**
		 * Log a error event for Mobile Creations to Ingest.
		 *
		 * @param mcErrorCode	string object indicating the error code
		 */
		logMobileCreationsErrorEvent: function(mcErrorCode) {

			var mcEventData = {
				eventAction: 'error',
				errorCode : mcErrorCode
			};

			this.logMobileCreationsEvent(mcEventData);
		},

		/**
		 * Log an event from the FNFT dialog.
		 *
		 * @param itemData          item data to log
		 */
		logFNFTItemEvent: function( itemData ) {

			var ingestPayloadData = this.createPayload();

			ingestPayloadData.eventType = 'uc-file-open';
			ingestPayloadData.fileOpenType = 'new';

			iaw.util.assign(ingestPayloadData, itemData);
			this.postEvent(ingestPayloadData);
		},

		/**
		 * Log an analytics call for the FNFT grid item render event.
		 *
		 * @param itemData			grid item's data parameters
		 * @param section 			category section ID string
		 */
		logFNFTItemRenderedEvent: function( itemData ) {
			// window.alert(JSON.stringify(itemData));
			/*
				{
				   "name":"Custom (1074 x 1394 px @ 72 ppi)",
				   "tip":"Start a new Custom (1074 x 1394 px @ 72 ppi) document - 1074 x 1394 px",
				   "group":"",
				   "width":1074,
				   "height":1394,
				   "showInFNFT":false,
				   "units":"pixelsUnit",
				   "profile":"sRGB IEC61966-2.1",
				   "resolution":72,
				   "resolutionUnits":"inchesUnit",
				   "depth":8,
				   "scale":1,
				   "mode":"RGB",
				   "fill":"white",
				   "lastUsedTime":1466528752889,
				   "isPreset":true,
				   "id":"",
				   "title":"Custom (1074 x 1394 px @ 72 ppi)",
				   "description":"",
				   "thumbnail_url":"SP_PresetCustom.png",
				   "mime_type":"image/photoshop",
				   "price_prompt":"",
				   "template_category":"recent",
				   "previews":[],
				   "uuid":"f707810544c34470a5e048664fcaa5b2"
				}
				{
				   "name":"Clipboard",
				   "tip":"Start a new Clipboard document - 565 x 396 px",
				   "group":"clipboard",
				   "width":565,
				   "height":396,
				   "showInFNFT":true,
				   "units":"pixelsUnit",
				   "profile":"Display",
				   "resolution":72,
				   "resolutionUnits":"inchesUnit",
				   "depth":8,
				   "scale":1,
				   "mode":"RGB",
				   "isPreset":true,
				   "id":"",
				   "title":"Clipboard",
				   "description":"",
				   "thumbnail_url":"SP_PresetClipboard.png",
				   "mime_type":"image/photoshop",
				   "price_prompt":"",
				   "template_category":"recent",
				   "previews":[],
				   "uuid":"e258641a2e264aea9fe9b0692103457a"
				}
				{
				   "id":111631092,
				   "title":"Photo Album Presentation",
				   "description":"##### Two easy-to-use photo album mockups\r##### What's included:\r* Smart objects\r* Fully editable\r* High resolution\r* Great for presenting book layouts\r\r\r",
				   "marketing_text":null,
				   "thumbnail_url":"/Users/mortimer/Library/Caches/Adobe/CCX Welcome/stock/assets/0a529bbf-ce4d-4db3-8d1c-3d851d8ac897.jpeg",
				   "width":2048,
				   "height":1424,
				   "mime_type":"image/vnd.adobe.photoshop.template",
				   "size":16634446,
				   "template_category":[
				      "photo"
				   ],
				   "previews":[
				      {
				         "url":"/Users/mortimer/Library/Caches/Adobe/CCX Welcome/stock/assets/fbc0094f-0e27-4c79-9b76-9e87bc77fb0e.jpeg"
				      }
				   ],
				   "units":"inches",
				   "resolution":"72",
				   "price_prompt":"free",
				   "lastUsedTime":0,
				   "uuid":"a4d794f391274c32a11d02bab2005c75"
				}
			*/
			var itemPayloadData = {
				// debugIt: true,
				eventAction: 'render',
				cardTypeName: itemData.activeFilter,
				displayMode: (itemData.displayPosition >= 0) ? itemData.displayPosition : -1,
				sectionView: (itemData.group && itemData.group === 'clipboard') ? 'clipboard' : 'blank',
				displayTemplate: itemData.isPreset ? 'preset' : 'stock-template',
				cardName: itemData.name || itemData.title,
				cardID: itemData.id || 'preset'
			};

			// for templates - add in the price parameter data
			if (!itemData.isPreset) {
				itemPayloadData.attributes = { price: itemData.price_prompt };
			}
			this.logFNFTItemEvent(itemPayloadData);
		},

		/**
		 * Collected utility methods for setting FNFT sturcture data
		 */
		fnftUtil: {
			/**
			 * Utility method to set the common parameters related to both Preset and Stock template data.
			 *
			 * @param payload 				target Ingest payload object to update
			 * @param data  				source data object
			 */
			setCommonPayloadParameters: function(payload, data) {
				payload.displayMode = data.displayPosition;
				payload.cardTypeName = data.activeFilter;
				payload.cardName = data.title;
				payload.cardID = data.id || 'preset';
			},

			/**
			 * Utility method to set the common parameters related to Stock template data.
			 *
			 * @param payload 				target Ingest payload object to update
			 * @param data  				source Stock template data object
			 */
			setCommonStockPayloadParameters: function(payload, data) {
				this.setCommonPayloadParameters(payload, data);
				payload.displayTemplate = 'stock-template';
				payload.attributes = {
					price: data.price_prompt
				};
			},

			/**
			 * Utility method to set the common parameters related to Preset data.
			 *
			 * @param payload 				target Ingest payload object to update
			 * @param data  				source preset data object
			 */
			setCommonPresetPayloadParameters: function(payload, data) {
				this.setCommonPayloadParameters(payload, data);
				payload.displayTemplate = 'preset';
				payload.attributes = { };
				this.setAttributesFromPreset(payload.attributes, data);
			},

			/**
			 * Utility method to set only the parameters on the 'attributes' object that we care about.
			 *
			 * @param attributes 			target preset attributes object to update
			 * @param preset  				source preset data object
			 */
			setAttributesFromPreset: function(attributes, preset) {
				for (var key in preset) {
					switch (key) {
						case 'width':
						case 'height':
						case 'mode':
						case 'units':
						case 'profile':
						case 'fill':
						case 'resolution':
						case 'resolutionUnits':
							attributes[key] = preset[key];
							break;

						default:
							break;
					}
				}
			}
		},

		/**
		 * Log an analytics call for the FNFT action event.
		 *
		 * @param actionData		grid item's data parameters
		 */
		logFNFTActionClickedEvent: function( action, actionData ) {
			var actionPayloadData = {
				// debugIt: true,
				eventAction: 'click',
				ucAction: action
			};
			actionData = actionData || {};
			switch (action) {
				case 'preset-selected':
					this.fnftUtil.setCommonPresetPayloadParameters(actionPayloadData, actionData);
					delete actionPayloadData.ucAction;
					break;

				case 'template-selected':
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					delete actionPayloadData.ucAction;
					break;

				case 'stock-search':
					actionPayloadData.displayTemplate = 'stock-template';
					actionPayloadData.cardTypeName = actionData.activeFilter;
					actionPayloadData.actionURL = actionData.actionURL + '&as_content=ccxstart-search';
					break;

				case 'stock-sidebar':
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					actionPayloadData.actionURL = actionData.actionURL + '&as_content=ccxstart-sidebar';
					break;

				case 'render-preview':
					actionPayloadData.eventAction = 'render';
					actionPayloadData.ucAction = 'preview';
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					break;

				case 'close-template':
					actionPayloadData.ucAction = 'close';
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					break;

				case 'open-template':
					actionPayloadData.ucAction = 'open';
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					break;

				case 'preview':
				case 'preview-close':
				case 'preview-back':
				case 'license-template':
				case 'download-start':
				case 'download-end':
				case 'download':
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					break;

				case 'too-large-render':
					this.fnftUtil.setCommonStockPayloadParameters(actionPayloadData, actionData);
					actionPayloadData.ucAction = 'download-large';
					actionPayloadData.eventAction = 'render';
					break;

				case 'close':
					this.fnftUtil.setCommonPresetPayloadParameters(actionPayloadData, actionData);
					break;

				case 'preset-viewmore':
					this.fnftUtil.setCommonPresetPayloadParameters(actionPayloadData, actionData);
					actionPayloadData.ucAction = 'viewmore';
					delete actionPayloadData.attributes;
					break;

				case 'preset-create':
					this.fnftUtil.setCommonPresetPayloadParameters(actionPayloadData, actionData);
					actionPayloadData.attributesChanged = false;
					actionPayloadData.ucAction = 'create';

					// check for the 'settings' data added which indicates a preset MAY have changed
					if (actionData.settings && Object.keys(actionData.settings).length !== 0 && actionData.settings.constructor === Object) {
						actionPayloadData.attributesChanged = actionData.settings.attributesChanged || false;
						// only add changed attributes if there were actual changes
						if (actionPayloadData.attributesChanged) {
							actionPayloadData.newAttributes = {};
							this.fnftUtil.setAttributesFromPreset(actionPayloadData.newAttributes, actionData.settings);
						}
					}
					break;

				case 'more-options':
					this.fnftUtil.setCommonPresetPayloadParameters(actionPayloadData, actionData);
					iaw.util.assign(actionPayloadData, actionData.presetAttributes);
					break;

				case 'tab-selected':
					actionPayloadData.cardTypeName = actionData.activeFilter;
					break;

				case 'welcome-rendered':
					actionPayloadData.displayTemplate = 'welcome';
					actionPayloadData.eventAction = 'render';
					actionPayloadData.displayCount = actionData.displayCount;
					actionPayloadData.cardTypeName = actionData.activeFilter;
					actionPayloadData.ucAction = 'render';
					break;

				case 'welcome-closed':
					actionPayloadData.displayTemplate = 'welcome';
					actionPayloadData.cardTypeName = actionData.activeFilter;
					actionPayloadData.ucAction = 'close';
					break;

				case 'resize-dialog':
					actionPayloadData.eventAction = 'resize';
					actionPayloadData.displayTemplate = actionData.displayTemplate;
					actionPayloadData.cardName = actionData.cardName;
					actionPayloadData.cardTypeName = actionData.activeFilter;
					if (actionData.displayMode >= 0) {
						actionPayloadData.displayMode = actionData.displayMode;
					}
					actionPayloadData.attributes = actionData.attributes;
					delete actionPayloadData.ucAction;
					break;

				default:
					break;
			}
			this.logFNFTItemEvent(actionPayloadData);
		}
	} // end of ingest container
};
